<div 
  [ngClass]="[
    backgroundColor,
    'col-span-full flex justify-between items-center',
    removePadding ? '' : 'pb-4 pt-4'
  ]"
>
  @if(showTotalEntries){
    <div [ngClass]="removePadding ? '' : 'pl-6'" class="orange-text text-xs">
      Showing {{ displaySize }} of {{ totalItems }} entries
    </div>
  } @else {
    <ng-content></ng-content>
  }

  <div [ngClass]="removePadding ? '' : 'pr-6'" class="flex items-center justify-end table-pagination text-xs">

    <!-- Previous Button -->
    <button 
      class="page-btn sarabun-bold orange-box px-2 py-1" 
      style="white-space: nowrap;" 
      [disabled]="currentPage === 1" 
      [ngClass]="{'opacity-50 cursor-not-allowed pointer-events-none': currentPage === 1}"
      (click)="onPrevious()">
      Previous
    </button>

    <!-- First page -->
    <ng-container *ngIf="pagesArray[0] > 1">
      <button 
        class="page-btn sarabun-bold orange-box px-2 py-1"
        style="white-space: nowrap;" 
        (click)="onSetPage(1)"
      >1</button>
      <!-- Ellipsis -->
      <button 
        *ngIf="pagesArray[0] > 2"
        class="page-btn sarabun-bold orange-box px-2 py-1" 
        style="white-space: nowrap;" 
        disabled
      >...</button>
    </ng-container>

    <!-- Window pages (currentPage-1, currentPage, currentPage+1) -->
    <button 
      *ngFor="let item of pagesArray"
      class="page-btn sarabun-bold orange-box px-2 py-1" 
      [ngClass]="{'active': currentPage === item}" 
      style="white-space: nowrap;" 
      (click)="onSetPage(item)"
    >{{ item }}</button>

    <!-- Last page -->
    <ng-container *ngIf="pagesArray[pagesArray.length - 1] < totalPages">
      <!-- Ellipsis -->
      <button 
        *ngIf="pagesArray[pagesArray.length - 1] < totalPages - 1"
        class="page-btn sarabun-bold orange-box px-2 py-1" 
        style="white-space: nowrap;" 
        disabled
      >...</button>
      <button 
        class="page-btn sarabun-bold orange-box px-2 py-1"
        style="white-space: nowrap;" 
        (click)="onSetPage(totalPages)"
      >{{ totalPages }}</button>
    </ng-container>

    <!-- Next Button -->
    <button 
      class="page-btn sarabun-bold orange-box px-2 py-1" 
      style="white-space: nowrap;" 
      [disabled]="currentPage === totalPages" 
      [ngClass]="{'opacity-50 cursor-not-allowed pointer-events-none': currentPage === totalPages}"
      (click)="onNext()">
      Next
    </button>

  </div>
</div>